import {PermissionModel} from '../../model/users/PermissionModel.js';
import {BaseCollection} from '../BaseCollection';

/**
 * @class PermissionCollection
 * @extends BaseCollection
 */
export class PermissionCollection extends BaseCollection {

    initialize (models, options) {

        super.initialize(models, options);

        this.microservice = 'users';
        this.resource = 'permissions';
    }

    get model () {

        return PermissionModel;
    }

    /**
     * @description Compare models for sorting based on name in ascending order.
     *
     * @param {PermissionModel} a
     * @param {PermissionModel} b
     *
     * @returns {number} sort order
     */
    static cmpByName (a, b) {
        
        const first = -1, second = 1, same = 0;
        const name1 = a.get('name').toLowerCase();
        const name2 = b.get('name').toLowerCase();
        try {
            if( name1 > name2) {
                return second;
            } else if (name2 > name1) {
                return first;
            } else {
                return same;
            }
        }
        catch (error) {
            return same;
        }
    }

    /**
     * @description Compare models for sorting based on name in descending order.
     */
    static cmpByNameDesc (a, b) {

        return -PermissionCollection.cmpByName(a, b);
    }
}


// WEBPACK FOOTER //
// ./shared/collection/users/PermissionCollection.js